import { useApiQuery, useApiMutation } from "lib/react-query";

/**
 * Unified top-bar counters for the current agent user (tenant base):
 * { notifications, pending_tasks, contact_messages, support_tickets }.
 * Polled so the badges stay fresh without a manual refresh.
 */
export const useTopBarCounters = () =>
  useApiQuery(
    "dashboard/statistics/top-bar-counters",
    null,
    false,
    null,
    {},
    { refetchInterval: 60000, staleTime: 30000 }
  );

/** Recent agent notifications for the bell slide-down (fetched when opened). */
export const useAgentNotifications = (enabled = false) =>
  useApiQuery("dashboard/notifications", 1, false, null, {}, { enabled });

/**
 * Full paginated notifications list for the notifications-center page.
 * `filters` (read / per_page) are passed as the `otherParam` so the caller keeps
 * full control over the read-state tab without relying on URL-param forwarding.
 */
export const useAllNotifications = (page, filters) =>
  useApiQuery("dashboard/notifications", page, false, filters);

/**
 * Mutations for the notifications menu / center — mark-all-read plus the
 * per-notification read/unread toggles (issued as PATCH via `update`).
 */
export const useNotificationsMutation = (callbacks = {}) =>
  useApiMutation(callbacks);

export const NOTIFICATIONS_READ_ALL_URL = "dashboard/notifications/read-all";
export const notificationReadUrl = (id) => `dashboard/notifications/${id}/read`;
export const notificationUnreadUrl = (id) =>
  `dashboard/notifications/${id}/unread`;
